export default "__VITE_ASSET__CQWaNOIm__"